import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function PopularComics() {
  const popular = [...comics].sort((a, b) => b.views - a.views).slice(0, 6);

  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              万千读者的共同选择
            </p>
          </div>
          <Link
            to="/category/love"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 whitespace-nowrap flex items-center gap-1"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop>
          {popular.map((comic, idx) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 韩漫之家免费韩漫`}
                  title={`${comic.title} - 免费韩漫在线阅读`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium ${
                    comic.status === '连载中'
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-secondary-500 text-background-50'
                  }`}>
                    {comic.status}
                  </span>
                </div>
                {idx < 3 && (
                  <div className="absolute top-2 right-2 w-6 h-6 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-[10px] font-bold">
                    {idx + 1}
                  </div>
                )}
              </div>
              <h3 className="mt-3 text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors duration-200 line-clamp-1">
                {comic.title}
              </h3>
              <div className="mt-1 flex items-center gap-2">
                <div className="flex items-center gap-0.5">
                  <i className="ri-star-fill text-accent-500 text-[10px]"></i>
                  <span className="text-xs text-accent-600 font-medium">{comic.rating}</span>
                </div>
                <span className="text-xs text-foreground-400">
                  {comic.views > 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}次阅读
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}